import { render, staticRenderFns } from "./medical-discounts-view-card.vue?vue&type=template&id=3dc01dae&scoped=true&"
import script from "./medical-discounts-view-card.vue?vue&type=script&lang=js&"
export * from "./medical-discounts-view-card.vue?vue&type=script&lang=js&"
import style0 from "./medical-discounts-view-card.vue?vue&type=style&index=0&id=3dc01dae&prod&lang=scss&scoped=true&"
import style1 from "./medical-discounts-view-card.vue?vue&type=style&index=1&id=3dc01dae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc01dae",
  null
  
)

export default component.exports